import { jsx as _jsx } from "react/jsx-runtime";
import { getIconSizePx } from '#pplx/frontend/aether/components/Icon/getIconSizePx.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { useSpaceIconQuery } from '#pplx/frontend/apps/ask/collections/useSpaceIconQuery.js';
import { PerplexityEmoji } from '#pplx/frontend/components/PerplexityEmoji.js';
export const SpaceIconGlyph = ({ presentation, iconSize, emojiSize, appearanceClassName, }) => {
    const iconQuery = useSpaceIconQuery(presentation.type === 'appearance-icon' ? presentation.iconId : null);
    if (presentation.type === 'appearance-icon') {
        const entry = iconQuery.data;
        if (entry != null) {
            return (_jsx("span", { className: appearanceClassName, style: { color: presentation.colorStyle.icon }, children: _jsx(Icon, { icon: entry, size: iconSize }) }));
        }
        if (iconQuery.isLoading) {
            // Footprint-matching spacer so the icon resolving never reflows layout.
            const sizePx = getIconSizePx(iconSize ?? 'default');
            return (_jsx("span", { className: appearanceClassName, style: { color: presentation.colorStyle.icon }, children: _jsx("span", { "aria-hidden": true, className: "inline-flex shrink-0", style: { width: sizePx, height: sizePx } }) }));
        }
        // Unknown id (e.g. deploy skew): the async equivalent of the old sync
        // manifest-membership fallthrough.
        return (_jsx(SpaceIconGlyph, { presentation: presentation.fallback, iconSize: iconSize, emojiSize: emojiSize, appearanceClassName: appearanceClassName }));
    }
    if (presentation.type === 'emoji') {
        return _jsx(PerplexityEmoji, { unified: presentation.emoji, size: emojiSize });
    }
    return _jsx(Icon, { icon: presentation.icon, size: iconSize, color: presentation.color });
};
//# sourceMappingURL=SpaceIconGlyph.js.map